import type { ActionKeys } from '@/configs/router/actions';
import type Paths from '@/configs/router/paths';
import type { Relation } from '../utils';
import { toTree } from '../utils';
import type { Action, ActionMap, RouteItem, RouteMap } from './types';

export function genActionMap(baseMap: Record<ActionKeys, Omit<Action, 'key'>>) {
  for (const k in baseMap) {
    if (!('key' in baseMap[k as ActionKeys])) {
      (baseMap as any)[k].key = k;
    }
  }
  return baseMap as ActionMap;
}

export function genRouteMap(baseMap: RouteMap) {
  for (const k in baseMap) {
    if (!('path' in baseMap[k as Paths])) {
      baseMap[k as Paths].path = k;
    }
  }
  return baseMap;
}

export function genMenu(relation: Relation<RouteItem>) {
  return toTree(relation, ({ path, menu, auth }) => ({
    key: path as string,
    auth,
    ...menu,
  }));
}

export function genRoutesMap(baseMap: RouteMap, routeMap: RouteMap) {
  for (const k in baseMap) {
    Object.assign(baseMap[k as Paths], routeMap[k as Paths]);
  }
  return baseMap;
}
